var map = {
	"./cannabis-basics/cannabis-pharmacokinetics.vue": [
		"8a68",
		"chunk-2d0e88a1"
	],
	"./cannabis-basics/cbd-classic-drug.vue": [
		"38ab",
		"chunk-2d0bae3c"
	],
	"./cannabis-basics/classification-of-cannabis.vue": [
		"3304",
		"chunk-2d0b955a"
	],
	"./cannabis-basics/dig-deeper-entourage-hypothesis.vue": [
		"abe6",
		"chunk-2d213548"
	],
	"./cannabis-basics/learning-objectives.vue": [
		"8914",
		"chunk-2d0df1da"
	],
	"./cannabis-basics/opening-statement.vue": [
		"065f",
		"chunk-2d0a444d"
	],
	"./cannabis-basics/patients-ask-cbd.vue": [
		"3425",
		"chunk-2d0b995a"
	],
	"./cannabis-basics/patients-ask-raw-cannabis.vue": [
		"c3bc",
		"chunk-2d216d67"
	],
	"./cannabis-basics/patients-ask-strain.vue": [
		"eceb",
		"chunk-2d230ab1"
	],
	"./cannabis-basics/phytocannabinoids.vue": [
		"6e4d",
		"chunk-2d0daed5"
	],
	"./cannabis-basics/receptor-binding-thc.vue": [
		"227d",
		"chunk-2d0b1e43"
	],
	"./cannabis-basics/receptor-cbd.vue": [
		"47af",
		"chunk-2d0c1ede"
	],
	"./cannabis-basics/receptors-for-phytocannabinoids.vue": [
		"c385",
		"chunk-2d216823"
	],
	"./cannabis-basics/terpenes.vue": [
		"bb04",
		"chunk-2d21a33a"
	],
	"./cannabis-basics/what-strain-name.vue": [
		"5aa4",
		"chunk-2d0d30b5"
	],
	"./cannabis-effects-interactions/adverse-effects-range.vue": [
		"f177",
		"chunk-63d5f15a"
	],
	"./cannabis-effects-interactions/cannabinoids-cytochrome-p450.vue": [
		"d50f",
		"chunk-24146884"
	],
	"./cannabis-effects-interactions/cannabis-cns-depression.vue": [
		"6a4a",
		"chunk-2d0d9fce"
	],
	"./cannabis-effects-interactions/cannabis-excessive-sedation.vue": [
		"0b84",
		"chunk-2d0ae9a4"
	],
	"./cannabis-effects-interactions/cannabis-psychiatric-drugs.vue": [
		"4795",
		"chunk-2d0c19d5"
	],
	"./cannabis-effects-interactions/cardiovascular-cerebrovascular-events.vue": [
		"4d72",
		"chunk-2d0cc281"
	],
	"./cannabis-effects-interactions/contrainidications.vue": [
		"54802",
		"chunk-7483d705"
	],
	"./cannabis-effects-interactions/dig-deeper-acute-effects-administration.vue": [
		"34ad",
		"chunk-a787df74"
	],
	"./cannabis-effects-interactions/dig-deeper-cannabis-exposure-children.vue": [
		"bbe5",
		"chunk-2d21a9a6"
	],
	"./cannabis-effects-interactions/learning-objectives.vue": [
		"c3f1",
		"chunk-2d216db1"
	],
	"./cannabis-effects-interactions/opening-statement.vue": [
		"b155",
		"chunk-2d20ebe5"
	],
	"./cannabis-effects-interactions/patients-ask-can-cannabis-kill.vue": [
		"7b74",
		"chunk-2d0e181e"
	],
	"./cannabis-effects-interactions/patients-ask-cbd-everywhere.vue": [
		"27c3",
		"chunk-2d0b362b"
	],
	"./cannabis-effects-interactions/patients-ask-what-if-drugs-interact.vue": [
		"2c4c",
		"chunk-2d0bd5d6"
	],
	"./cannabis-effects-interactions/warnings.vue": [
		"b79e",
		"chunk-2d210317"
	],
	"./cannabis-policy-canada/accessing-cannabis-medical-stream.vue": [
		"7051",
		"chunk-2d0d5c2b"
	],
	"./cannabis-policy-canada/accessing-cannabis-retail-stream.vue": [
		"5fbb",
		"chunk-2d0d43c7"
	],
	"./cannabis-policy-canada/canadian-federal-regulations-medical-cannabis.vue": [
		"cf68",
		"chunk-2d22275b"
	],
	"./cannabis-policy-canada/cannabis-resources-for-health-care-practitioners.vue": [
		"9ed1",
		"chunk-2d0f118f"
	],
	"./cannabis-policy-canada/cannabis-workplace.vue": [
		"4409",
		"chunk-2d0c0d7f"
	],
	"./cannabis-policy-canada/classes-of-cannabis.vue": [
		"3de8",
		"chunk-2d0c53ba"
	],
	"./cannabis-policy-canada/criminalization-legalization-cannabis.vue": [
		"ebd2",
		"chunk-3cc19f8c"
	],
	"./cannabis-policy-canada/dig-deeper-canadian-medical-association-policy-cannabis.vue": [
		"e321",
		"chunk-d210bb22"
	],
	"./cannabis-policy-canada/dig-deeper-provincial-rules-cannabis-authorization.vue": [
		"c0a7",
		"chunk-2d2161d9"
	],
	"./cannabis-policy-canada/drug-impaired-driving.vue": [
		"3779",
		"chunk-2d0ba53c"
	],
	"./cannabis-policy-canada/hospitals-and-ltc.vue": [
		"a16d",
		"chunk-2d2077d4"
	],
	"./cannabis-policy-canada/learning-objectives.vue": [
		"920d",
		"chunk-2d0e4c03"
	],
	"./cannabis-policy-canada/medical-cannabis-in-canada-varying-perspectives.vue": [
		"38e5",
		"chunk-2d0bae8b"
	],
	"./cannabis-policy-canada/medical-document.vue": [
		"a042",
		"chunk-2d2073a3"
	],
	"./cannabis-policy-canada/new-policies-medical-documents.vue": [
		"4a39",
		"chunk-2d0cb6c9"
	],
	"./cannabis-policy-canada/opening-statement.vue": [
		"80c3",
		"chunk-2d0dd61e"
	],
	"./cannabis-policy-canada/other-health-care-practitioners.vue": [
		"3198",
		"chunk-2d0b8ef3"
	],
	"./cannabis-policy-canada/patients.vue": [
		"0726",
		"chunk-2d0a4781"
	],
	"./cannabis-policy-canada/physicians.vue": [
		"aeb0",
		"chunk-2d214028"
	],
	"./cannabis-policy-canada/possession-growing-limits.vue": [
		"13d3",
		"chunk-b85ed87e"
	],
	"./cannabis-policy-canada/provincial-territorial-cannabis-regulations.vue": [
		"c4b3",
		"chunk-2d2170f8"
	],
	"./cannabis-policy-canada/public-health-and-cannabis-legalization.vue": [
		"8efd",
		"chunk-2d0e9da1"
	],
	"./cannabis-policy-canada/regulations-non-medical-cannabis.vue": [
		"f654",
		"chunk-2d22d025"
	],
	"./cannabis-policy-canada/travel.vue": [
		"ebd1",
		"chunk-2d2306a0"
	],
	"./cannabis-policy-canada/where-cannabis-consumed.vue": [
		"cb6e",
		"chunk-0e4c2e18"
	],
	"./cannabis-use-disorder/at-risk-cws.vue": [
		"b4f3",
		"chunk-073e83b9"
	],
	"./cannabis-use-disorder/cannabis-use-disorder-criteria.vue": [
		"cb90",
		"chunk-2d2218ac"
	],
	"./cannabis-use-disorder/cannabis-use-disorder-risk.vue": [
		"3396",
		"chunk-2d0b9673"
	],
	"./cannabis-use-disorder/cannabis-use-identified.vue": [
		"85da",
		"chunk-2d0de930"
	],
	"./cannabis-use-disorder/cannabis-withdrawal-identification.vue": [
		"aecb",
		"chunk-7c6addbe"
	],
	"./cannabis-use-disorder/cannabis-withdrawal-syndrome.vue": [
		"90cb",
		"chunk-93e71d88"
	],
	"./cannabis-use-disorder/cud-cws-management.vue": [
		"19e2",
		"chunk-2d0ac98b"
	],
	"./cannabis-use-disorder/cud-remission-criteria.vue": [
		"1db2",
		"chunk-2d0b6a99"
	],
	"./cannabis-use-disorder/dig-deeper-cud-cwd-patient-management.vue": [
		"3788",
		"chunk-2d0ba55a"
	],
	"./cannabis-use-disorder/dig-deeper-cws-basis.vue": [
		"a54b",
		"chunk-2d208698"
	],
	"./cannabis-use-disorder/harms-cannabis-use.vue": [
		"da4c",
		"chunk-2d2288e2"
	],
	"./cannabis-use-disorder/learning-objectives.vue": [
		"a061",
		"chunk-2d2073e0"
	],
	"./cannabis-use-disorder/lower-risk-cannabis-use.vue": [
		"b2b2",
		"chunk-2d20f516"
	],
	"./cannabis-use-disorder/medical-help-cannabis-use.vue": [
		"225f",
		"chunk-2d0b1e07"
	],
	"./cannabis-use-disorder/medical-treatment-problematic-use.vue": [
		"50bf",
		"chunk-2d0c7915"
	],
	"./cannabis-use-disorder/opening-statement.vue": [
		"fea8",
		"chunk-2d2385ec"
	],
	"./cannabis-use-disorder/recommendations-cannabis-patients.vue": [
		"0429",
		"chunk-2d0a3c41"
	],
	"./cannabis-use-disorder/time-course-cws.vue": [
		"0959",
		"chunk-2d0a4f63"
	],
	"./cannabis-use-disorder/what-is-cannabis-use-disorder.vue": [
		"c737",
		"chunk-2d21768e"
	],
	"./clinical-use-cannabis-pain/animal-models-cancer-pain.vue": [
		"3dea",
		"chunk-2d0c53e3"
	],
	"./clinical-use-cannabis-pain/cannabinoids-adjunctive-therapy.vue": [
		"40ce",
		"chunk-2d0c04d4"
	],
	"./clinical-use-cannabis-pain/cannabinoids-effects-chronic-pain.vue": [
		"750a",
		"chunk-2d0d6e85"
	],
	"./clinical-use-cannabis-pain/cannabis-effects-cancer-pain.vue": [
		"c1e6",
		"chunk-2d216615"
	],
	"./clinical-use-cannabis-pain/cannabis-neuropathic-pain.vue": [
		"f832",
		"chunk-2d22d767"
	],
	"./clinical-use-cannabis-pain/cannabis-pain-hiv.vue": [
		"df2b",
		"chunk-2d229b68"
	],
	"./clinical-use-cannabis-pain/cannabis-use-non-cancer-pain.vue": [
		"fa9b",
		"chunk-2d23723a"
	],
	"./clinical-use-cannabis-pain/chronic-pain-public-healh-burden.vue": [
		"38d5",
		"chunk-2d0bae6c"
	],
	"./clinical-use-cannabis-pain/clinical-effects-cannabis-pain.vue": [
		"21f9",
		"chunk-2d0b2008"
	],
	"./clinical-use-cannabis-pain/common-pain-medications.vue": [
		"81dd",
		"chunk-58f31ce2"
	],
	"./clinical-use-cannabis-pain/comorbidity-cannabis-medicine.vue": [
		"f161",
		"chunk-2d22bd7c"
	],
	"./clinical-use-cannabis-pain/comorbidity-endocannabinoid-system.vue": [
		"40f6",
		"chunk-2d0c0502"
	],
	"./clinical-use-cannabis-pain/dig-deeper-evidence-level-cannabis.vue": [
		"7a54",
		"chunk-2d0e141f"
	],
	"./clinical-use-cannabis-pain/endocannabinoid-system-neuropathic-pain-control.vue": [
		"41c4",
		"chunk-2d0c0864"
	],
	"./clinical-use-cannabis-pain/endocannabinoid-system-pain-control.vue": [
		"9583",
		"chunk-2d0e580d"
	],
	"./clinical-use-cannabis-pain/learning-objectives.vue": [
		"cdb9",
		"chunk-2d22252e"
	],
	"./clinical-use-cannabis-pain/therapeutic-option-cannabinoids.vue": [
		"981d",
		"chunk-2d0e62a8"
	],
	"./clinical-use-cannabis-pain/types-of-pain.vue": [
		"056b",
		"chunk-2d0a40a7"
	],
	"./clinical-use-cannabis-pain/what-is-pain.vue": [
		"cf72",
		"chunk-2d222774"
	],
	"./clinical-use-therapeutic-applications/cannabinoids-effect-cinv.vue": [
		"3a45",
		"chunk-2d0c4285"
	],
	"./clinical-use-therapeutic-applications/cannabinoids-sleep.vue": [
		"620e",
		"chunk-2d0ceee7"
	],
	"./clinical-use-therapeutic-applications/cannabinoids-treatment-ms.vue": [
		"e8c5",
		"chunk-2d2268db"
	],
	"./clinical-use-therapeutic-applications/cannabis-adjunctive-treatment-chemotherapy.vue": [
		"3ab9",
		"chunk-2d0c481b"
	],
	"./clinical-use-therapeutic-applications/cannabis-anxiety.vue": [
		"3c3b",
		"chunk-2d0c4a15"
	],
	"./clinical-use-therapeutic-applications/cannabis-appetite-stimulation.vue": [
		"1832",
		"chunk-2d0abfbc"
	],
	"./clinical-use-therapeutic-applications/cannabis-crohns-disease.vue": [
		"e2cd",
		"chunk-2d225284"
	],
	"./clinical-use-therapeutic-applications/cannabis-medicine-ms.vue": [
		"1725",
		"chunk-2d0abbdf"
	],
	"./clinical-use-therapeutic-applications/cannabis-sleep-disorders.vue": [
		"a7ea",
		"chunk-2d209408"
	],
	"./clinical-use-therapeutic-applications/cannabis-symptom-relief-crohns-uc.vue": [
		"ccb3",
		"chunk-2d222167"
	],
	"./clinical-use-therapeutic-applications/cbd-additive-effects.vue": [
		"f0a6",
		"chunk-2d22bef5"
	],
	"./clinical-use-therapeutic-applications/cbd-animal-dravet-syndrome.vue": [
		"e90c",
		"chunk-2d22669d"
	],
	"./clinical-use-therapeutic-applications/cbd-epidiolex.vue": [
		"64c0",
		"chunk-2d0cfc61"
	],
	"./clinical-use-therapeutic-applications/cbd-pediatric-epilepsies.vue": [
		"a7ee",
		"chunk-2d20940c"
	],
	"./clinical-use-therapeutic-applications/cbd-social-anxiety.vue": [
		"3639",
		"chunk-2d0ba0ff"
	],
	"./clinical-use-therapeutic-applications/cbd-treatment-children-epilepsy.vue": [
		"525b",
		"chunk-2d0c7b20"
	],
	"./clinical-use-therapeutic-applications/cbd-treatment-heroin.vue": [
		"1009",
		"chunk-2d0aa15e"
	],
	"./clinical-use-therapeutic-applications/cbd-treatment-opioid.vue": [
		"dbda",
		"chunk-2d229271"
	],
	"./clinical-use-therapeutic-applications/dig-deeper-cannabis-opioid-addiction.vue": [
		"cccd",
		"chunk-2d2221b7"
	],
	"./clinical-use-therapeutic-applications/endocannabinoid-nausea.vue": [
		"90d8",
		"chunk-2d0e4aa1"
	],
	"./clinical-use-therapeutic-applications/endocannabinoid-system-disease-mouse-model.vue": [
		"ec32",
		"chunk-2d230473"
	],
	"./clinical-use-therapeutic-applications/evidence-cannabis-medicine.vue": [
		"18ce",
		"chunk-2d0ac5bf"
	],
	"./clinical-use-therapeutic-applications/extinction-traumatic-memories.vue": [
		"2739",
		"chunk-2d0b3061"
	],
	"./clinical-use-therapeutic-applications/learning-objectives.vue": [
		"bd78",
		"chunk-2d21ab99"
	],
	"./clinical-use-therapeutic-applications/ptsd-symptoms-reduction-cannabis.vue": [
		"6ce1",
		"chunk-2d0dad0f"
	],
	"./clinical-use-therapeutic-applications/regulatory-role-endocannabinoid-gut.vue": [
		"80d9",
		"chunk-2d0dd643"
	],
	"./clinical-use-therapeutic-applications/regulatory-role-endocannabinoid.vue": [
		"5e9d",
		"chunk-2d0d3b11"
	],
	"./clinical-use-therapeutic-applications/spasticity-ms.vue": [
		"c8b9",
		"chunk-2d218002"
	],
	"./clinical-use-therapeutic-applications/two-synthetic-cannabinoids-cinv.vue": [
		"9d5e",
		"chunk-2d0f0851"
	],
	"./considerations-authorizing-cannabis/additional-considerations.vue": [
		"8ae4",
		"chunk-2d0e8e4e"
	],
	"./considerations-authorizing-cannabis/cannabis-dosing-general-strategies.vue": [
		"0e29",
		"chunk-2d0af432"
	],
	"./considerations-authorizing-cannabis/cannabis-primary-care-consideration.vue": [
		"30f5",
		"chunk-2d0b90a2"
	],
	"./considerations-authorizing-cannabis/drug-to-drug-interactions-cannabis-cannabinoids.vue": [
		"54ba",
		"chunk-2d0c8814"
	],
	"./considerations-authorizing-cannabis/learning-objectives.vue": [
		"688e",
		"chunk-2d0d0665"
	],
	"./considerations-authorizing-cannabis/monitoring.vue": [
		"baaa",
		"chunk-2d21a595"
	],
	"./considerations-authorizing-cannabis/patient-history-cannabis-use.vue": [
		"09ec",
		"chunk-2d0a555d"
	],
	"./considerations-authorizing-cannabis/patients-ask-alcohol-interaction-cannabis.vue": [
		"0e05",
		"chunk-2d0af3f0"
	],
	"./considerations-authorizing-cannabis/patients-ask-cannabis-gain-weight.vue": [
		"9208",
		"chunk-2d0e4bd7"
	],
	"./considerations-authorizing-cannabis/patients-ask-therapeutic-benefits-thc-experience.vue": [
		"0c2d",
		"chunk-2d0aecdb"
	],
	"./considerations-authorizing-cannabis/potential-drug-interactions-nabiximols.vue": [
		"6cf7",
		"chunk-2d0dad34"
	],
	"./considerations-authorizing-cannabis/routes-of-administration.vue": [
		"8d72",
		"chunk-2fc2b5d6"
	],
	"./considerations-authorizing-cannabis/titration-strategies-cbd-chemovars.vue": [
		"7bb7",
		"chunk-2d0e1d56"
	],
	"./considerations-authorizing-cannabis/titration-strategies-oral-administration-thc.vue": [
		"66be",
		"chunk-2d0d03f9"
	],
	"./considerations-authorizing-cannabis/titration-strategies-vaporization-thc.vue": [
		"adec",
		"chunk-2d213cf7"
	],
	"./considerations-authorizing-cannabis/type-of-product-route-administration.vue": [
		"d6ac",
		"chunk-2d21ecea"
	],
	"./intro-to-ecs/components-of-ecs.vue": [
		"1f79",
		"chunk-2d0b6ced"
	],
	"./intro-to-ecs/dig-deeper-ecs-protective.vue": [
		"3b00",
		"chunk-2d0c45c5"
	],
	"./intro-to-ecs/dig-deeper-expanding-ecs.vue": [
		"54fa",
		"chunk-2d0c8890"
	],
	"./intro-to-ecs/dig-deeper-faah-out.vue": [
		"c238",
		"chunk-2d2163ca"
	],
	"./intro-to-ecs/dig-deeper-feeding-behaviour.vue": [
		"9e41",
		"chunk-2d0f0bbf"
	],
	"./intro-to-ecs/dig-deeper-hypothalamus.vue": [
		"4317",
		"chunk-2d0c09db"
	],
	"./intro-to-ecs/endocannabinoids.vue": [
		"103d",
		"chunk-2d0aa1e6"
	],
	"./intro-to-ecs/genetic-variation-ecs.vue": [
		"5cf4",
		"chunk-2d0d38d2"
	],
	"./intro-to-ecs/homeostasis-and-ecs.vue": [
		"1db1",
		"chunk-2d0b6a98"
	],
	"./intro-to-ecs/learning-objectives.vue": [
		"5480",
		"chunk-2d0c82cd"
	],
	"./intro-to-ecs/opening-statement.vue": [
		"10a1",
		"chunk-2d0aa745"
	],
	"./intro-to-ecs/patients-ask-deficiency.vue": [
		"052a",
		"chunk-2d0a402a"
	],
	"./intro-to-ecs/patients-ask-spice.vue": [
		"5911",
		"chunk-2d0c94ba"
	],
	"./intro-to-ecs/signalling-cannabinoid-receptors.vue": [
		"a579",
		"chunk-2d2086cc"
	],
	"./intro-to-ecs/synthetic-and-metabolic-enzymes.vue": [
		"4c41",
		"chunk-2d0cbe62"
	],
	"./intro-to-ecs/variability-of-ecs.vue": [
		"adb1",
		"chunk-2d213c68"
	],
	"./long-term-health-cannabis/cannabis-and-cardiovascular-disease.vue": [
		"5e69",
		"chunk-2d0d3a89"
	],
	"./long-term-health-cannabis/cannabis-use-elderly.vue": [
		"1fbb",
		"chunk-2d0b724b"
	],
	"./long-term-health-cannabis/cannabis-use-male-fertility.vue": [
		"eb7d",
		"chunk-2d230160"
	],
	"./long-term-health-cannabis/cannabis-use-sexual-function.vue": [
		"5814",
		"chunk-2d0c90fc"
	],
	"./long-term-health-cannabis/chronic-cannabis-cancer-risk.vue": [
		"2014",
		"chunk-2d0b15d7"
	],
	"./long-term-health-cannabis/chronic-cannabis-hyperemesis.vue": [
		"e1e9",
		"chunk-2d224ed6"
	],
	"./long-term-health-cannabis/chronic-cannabis-smoking.vue": [
		"614d",
		"chunk-2d0ceba1"
	],
	"./long-term-health-cannabis/chronic-cannabis-use-deficits.vue": [
		"78a1",
		"chunk-2d0d7f87"
	],
	"./long-term-health-cannabis/dig-deeper-brain-structure.vue": [
		"f0c0",
		"chunk-2d22bf2d"
	],
	"./long-term-health-cannabis/dig-deeper-ecs-prenatal.vue": [
		"e25c",
		"chunk-2d224cf1"
	],
	"./long-term-health-cannabis/dig-deeper-elderly-cannabis-use.vue": [
		"6925",
		"chunk-2d0d093c"
	],
	"./long-term-health-cannabis/learning-objectives.vue": [
		"6050",
		"chunk-2d0ce7cb"
	],
	"./long-term-health-cannabis/long-term-cannabis-use.vue": [
		"c1a9",
		"chunk-2d21659c"
	],
	"./long-term-health-cannabis/neurocognitive-effects-cannabis.vue": [
		"cace",
		"chunk-2d221a36"
	],
	"./long-term-health-cannabis/patients-ask-vaporize.vue": [
		"1971",
		"chunk-2d0ac3f8"
	],
	"./long-term-health-cannabis/prenatal-exposure.vue": [
		"8db3",
		"chunk-2d0e9933"
	],
	"./long-term-health-cannabis/prolonged-cannabis-use-health-outcomes.vue": [
		"6b3f",
		"chunk-2d0da375"
	],
	"./long-term-health-cannabis/recap.vue": [
		"f617",
		"chunk-2d22cfac"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4a43";
module.exports = webpackAsyncContext;